<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0,0,${width},${height}`"
  >
    <svg v-for="(data, i) of boxData">
      <rect
        :width="boxWidth"
        :height="height"
        :x="(boxWidth + GAP_WIDTH) * i"
        :fill="data.boxColor"
      ></rect>
      <text
        dominant-baseline="middle"
        text-anchor="middle"
        font-weight="900"
        font-size="11"
        :y="height / 2 + 1"
        :x="((boxWidth + GAP_WIDTH) * i) + (boxWidth / 2)"
        :fill="data.fontColor"
      >{{ data.displayValue }}</text>
    </svg>
  </svg>
</template>

<script lang="ts" setup>
  import { computed, toRefs } from 'vue';
  import { useMarketCarpetContext } from '@/ts/marketCarpetContext';

  const { getLeafColor, numericSteps, calculator, period } = useMarketCarpetContext();

  const props = defineProps<{
    height: number;
    boxWidth: number;
    boxCount: number;
  }>();

  const { height, boxCount, boxWidth } = toRefs(props);

  const boxData = computed(() => {
    const totalSteps = numericSteps.value.length;
    const count = Math.min(boxCount.value, totalSteps);
    const data: { boxColor: string, fontColor: string, displayValue: string }[] = [];

    for (let i = 0; i < count; i++) {
      const stepIndex = count <= 1 ? 0 : Math.round(i * (totalSteps - 1) / (count - 1));
      const { boxColor, fontColor } = getLeafColor(numericSteps.value[stepIndex]);

      data.push({
        boxColor,
        fontColor,
        displayValue: calculator.value.convertCondensed(numericSteps.value[stepIndex], period.value)
      });
    }

    return data;
  });

  const GAP_WIDTH = 3;

  const width = computed(() => {
    const renderedBoxCount = boxData.value.length;

    if (renderedBoxCount === 0)
      return 0;

    return renderedBoxCount * boxWidth.value + (renderedBoxCount - 1) * GAP_WIDTH;
  });
</script>
